import EventResult from "components/EventResult";
import ResponsesResultTable from "components/ResponsesResultTable";
import React from "react";
import { useTSelector } from "rx/store";
import EventDataListener from "utils/DataListener";

const ResultOnly: React.FC<{ responses?: boolean }> = ({ responses }) => {
  const eventId = useTSelector(s => s.eventId)
  return (
    <div>
      {eventId && responses ?
        <ResponsesResultTable eventId={eventId} />
        :
        <EventResult />
      }
      <EventDataListener resultOnly={true} />
    </div>
  );
};

export default ResultOnly;
